import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DirectDebitService {
  
  // region Atributos
  private API_URL = environment.url_direct_debit;
  // endregion

  // region Constructor
  constructor(
    private httpClient: HttpClient,
  ) { }
  // endregion

  // region Métodos

  public getCountries(): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/location/countries`).pipe(map(res =>  {
      return res;
    }));
  }

  public getStates(country_id): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/location/states/${country_id}`).pipe(map(res =>  {
      return res;
    }));
  }

  public getCities(state_code): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/location/cities/${state_code}`).pipe(map(res =>  {
      return res;
    }));
  }
}
